import React, { useCallback } from 'react'

import { Button, Modal, Text } from '@driftt/dds'

import useMeetingTypesList from 'hooks/useMeetingTypesList'
import useNotification from 'hooks/useNotification'
import { MeetingTypeWithId } from 'types/MeetingType'
import { trackMeetingDeleted } from 'utils/tracking'

interface DeleteMeetingTypeModalProps {
  meeting: MeetingTypeWithId | undefined
  onClose: () => void
}
export default function DeleteMeetingTypeModal({
  meeting,
  onClose,
}: DeleteMeetingTypeModalProps) {
  const { onDeleteMeetingType } = useMeetingTypesList()
  const notify = useNotification()

  const handleDeleteMeetingType = useCallback(() => {
    if (meeting) {
      onDeleteMeetingType(meeting)
      trackMeetingDeleted()
      notify('Meeting type deleted successfully!')
      onClose()
    }
  }, [meeting, onDeleteMeetingType, onClose, notify])

  return (
    <Modal.Root open={!!meeting} onClose={onClose}>
      <Modal.Dialog size="small" variant="warning">
        <Modal.Title title={`Delete ${meeting?.name}`} />
        <Modal.Content>
          <Text>
            Are you sure you want to delete the "{meeting?.name}" meeting type?
          </Text>
        </Modal.Content>
        <Modal.Actions>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleDeleteMeetingType}>
            Continue
          </Button>
        </Modal.Actions>
      </Modal.Dialog>
    </Modal.Root>
  )
}
